import * as React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

const NavLinkNewTab = React.forwardRef<any, any>((props, ref) => (
  <RouterNavLink
    ref={ref}
    target='_blank'
    to={props.to}
    className={({ isActive }) =>
      `${props.className} ${isActive ? props.activeClassName : ''}`
    }
  >
    {props.children}
  </RouterNavLink>
));

export default NavLinkNewTab;
